import { styled } from "styled-components";

export const QualificationsContainer = styled.div``;

export const QualificationsWrapper = styled.div`
  padding: 80px 0;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;
export const QualificationsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
  @media all and (max-width: 768px) {
    gap: 7.813vw;
  }
`;
export const QualificationsListWrap = styled.ul`
  display: flex;
  gap: 40px;
  li {
    width: calc(50% - 20px);
    padding: 32px 24px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    border-radius: 16px;
    border: 1px solid #dfdfdf;
    height: fit-content;
    h4 {
      font-size: 32px;
      line-height: 1.3;
      color: #233e99;
      font-weight: bold;
    }
    .title-text-wrap {
      display: flex;
      flex-direction: column;
      gap: 5px;
      border: 0 none;
      p {
        font-size: 20px;
        color: #555;
        position: relative;
        padding-left: 20px;
        text-align: left;
        &::after {
          content: "";
          width: 5px;
          height: 5px;
          position: absolute;
          background: #555;
          border-radius: 50%;
          top: 50%;
          left: 6px;
          transform: translateY(-50%);
        }
      }
    }
    > div {
      border: 1px solid #dfdfdf;
      border-bottom: 0 none;
      dl {
        border-bottom: 1px solid #dfdfdf;
        display: flex;
        dt {
          width: 110px;
          border-right: 1px solid #dfdfdf;
          padding: 20px 24px;
          font-size: 16px;
          line-height: 1.5;
          color: #555;
          display: flex;
          align-items: center;
          height: auto;
          font-weight: bold;
          background-color: #f7f7f7;
        }
        dd {
          flex: 1;
          padding: 8px;
          p {
            font-size: 16px;
            word-break: keep-all;
            line-height: 1.3;
            color: #555;
            position: relative;
            padding-left: 16px;
            text-align: left;
            &::after {
              content: "";
              width: 3px;
              height: 3px;
              position: absolute;
              background: #555;
              border-radius: 50%;
              top: 7px;
              left: 6px;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    flex-direction: column;
    gap: 30px;
    li {
      width: 100%;
    }
  }
  @media all and (max-width: 768px) {
    gap: 3.906vw;
    li {
      padding: 4.688vw 3.646vw;
      gap: 3.385vw;
      border-radius: 2.604vw;
      h4 {
        font-size: 5.208vw;
      }
      .title-text-wrap {
        gap: 1.042vw;
        p {
          font-size: 3.646vw;

          padding-left: 3.646vw;
          &::after {
            width: 1.042vw;
            height: 1.042vw;
            left: 1.172vw;
          }
        }
      }
      > div {
        dl {
          dt {
            width: 18.229vw;
            padding: 2.604vw 3.125vw;
            font-size: 3.385vw;
          }
          dd {
            padding: 2.083vw 1.563vw;
            p {
              font-size: 3.385vw;
              padding-left: 3.125vw;
              &::after {
                width: 0.651vw;
                height: 0.651vw;
                top: 1.432vw;
                left: 1.042vw;
              }
            }
          }
        }
      }
    }
  }
`;

export const QualificationsInfoWrap = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  gap: 40px;
  background-color: #f5f4f3;
  .text-wrap {
    width: 220px;
    color: #fbfbfb;
    background: #555;
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .info-wrap {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex: 1;
    gap: 8px;
    li {
      width: calc(50% - 4px);
      p {
        font-size: 14px;
        word-break: keep-all;
        line-height: 1.3;
        color: #555;
        position: relative;
        padding-left: 16px;
        text-align: left;
        &::after {
          content: "";
          width: 2px;
          height: 2px;
          position: absolute;
          background: #555;
          border-radius: 50%;
          top: 6px;
          left: 6px;
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    .text-wrap {
      width: 180px;
    }
  }
  @media all and (max-width: 768px) {
    padding: 2.083vw;
    gap: 2.344vw;
    flex-direction: column;
    .text-wrap {
      width: 100%;
      font-size: 3.646vw;
      padding: 1.563vw 0;
    }
    .info-wrap {
      gap: 1.042vw;
      li {
        width: calc(50% - 0.521vw);
        p {
          font-size: 3.385vw;

          padding-left: 3.125vw;

          &::after {
            width: 0.521vw;
            height: 0.521vw;

            top: 1.693vw;
            left: 1.302vw;
          }
        }
      }
    }
  }
`;

export const QualificationsContactusWrapper = styled.div`
  background-color: #233e99;
  padding: 40px 0;
  @media all and (max-width: 768px) {
    padding: 6.51vw 0;
  }
`;

export const QualificationsContactusWrap = styled.ul`
  display: flex;
  gap: 40px;
  li {
    width: calc(50% - 20px);

    a,
    button {
      &.mobile-button {
        display: none;
      }
      cursor: pointer;
      padding: 24px;
      border: 1px solid #8798d2;
      display: flex;
      align-items: center;
      gap: 20px;
      background: transparent;
      width: 100%;
      color: #fbfbfb;
      > div {
        flex: 1;
        justify-content: space-between;
        display: flex;
        align-items: center;
        .text-wrap {
          display: flex;
          flex-direction: column;
          text-align: left;
          gap: 4px;
          h6 {
            font-size: 24px;
            line-height: 1.3;
            font-weight: bold;
          }
          p {
            font-size: 16px;
            line-height: 1.3;
          }
        }
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
  @media all and (max-width: 900px) {
    li {
      a,
      button {
        &.pc-button {
          display: none;
        }
        &.mobile-button {
          display: flex;
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    gap: 2.604vw;
    li {
      width: calc(50% - 1.302vw);
      a,
      button {
        padding: 3.125vw 2.344vw;
        gap: 1.823vw;

        > div {
          .text-wrap {
            gap: 0.521vw;
            h6 {
              font-size: 3.646vw;
            }
            p {
              font-size: 3.125vw;
            }
          }
        }
        img {
          width: 5.208vw;
          height: 5.208vw;
        }
      }
    }
  }
`;
